<template>
  <div class="wrapper header">
    <div class="header_top" :style="{
      borderBottom:
        menutype == 1
          ? '1px solid #4f8ecb'
          : menutype == 2
            ? '1px solid #40ABDC'
            : '1px solid #41BAD9',
    }">
      <div class="contentwidth header_top_content">
        <div class="flex logo_box">
          <div class="logo_left" @click="returnHome"></div>
          <div :class="menutype == 1 ? 'logo1' : menutype == 2 ? 'logo2' : ''"></div>
        </div>

        <div class="flex menunew">
          <p @click="check('临床试验中心')" v-if="menutype != 1">
            临床试验中心>
          </p>
          <p @click="check('医学伦理委员会')" v-if="menutype != 2">
            医学伦理委员会>
          </p>
<!--          <p @click="check('技术转移机构')" v-if="menutype != 3">-->
<!--            技术转移机构>-->
<!--          </p>-->
          <!-- <p @click="returnold">返回旧版></p> -->
        </div>

        <!-- <el-tooltip
          placement="bottom"
          effect="light"
          class="header_tooltip"
          width="148"
        >
          <div slot="content">
            <div class="header_tooltip_erweima">
              <img
                v-if="menutype == 1 || menutype == 2"
                src="../../static/images/common/erweima.jpg"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="menutype == 3"
                src="../../static/images/common/erweima2.jpg"
                style="width: 100%; height: 100%"
              />
            </div>
            <p class="header_tooltip_text">扫一扫</p>
            <p class="header_tooltip_text">关注实时信息</p>
          </div>
          <div class="flex header_top_right_in">
            <i class="weixinIcon"></i>
            <span>微信公众号</span>
          </div>
        </el-tooltip> -->
        <!-- <el-input
          placeholder="请输入内容"
          class="header_search"
          v-model="searchInput"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            class="header_search_btn"
          ></el-button>
        </el-input> -->
      </div>
    </div>
    <div class="wrapper" :style="{
      backgroundColor:
        menutype == 1 ? '#2975D3' : menutype == 2 ? '#008FD0' : '#02A3CC',
    }">
      <div class="contentwidth nav">
        <ul :class="menutype == 1 ? 'active1' : menutype == 2 ? 'active2' : 'active3'
          ">
          <div class="nav_main" v-for="(item, index) in menuList" :key="index">
            <el-dropdown class="menu_dropdown" placement="bottom" style="width: 100%" @command="goCommand">
              <a @click="check(item.menu, index)" exact v-if="item.menu == '医学伦理委员会' || item.menu == '技术转移机构'
                " style="cursor: pointer">
                <li :style="{ padding: menutype == 1 ? '0 20px' : '0 30px' }">
                  <div>{{ item.menu }}</div>
                </li>
              </a>
              <router-link :to="item.url" @click.native="check(item.menu, index)" exact v-else>
                <li :style="{ padding: menutype == 1 ? '0 20px' : '0 50px' }">
                  <div>{{ item.menu }}</div>
                </li>
              </router-link>
              <el-dropdown-menu :append-to-body="false" slot="dropdown" v-if="item.children.length > 0" :class="menutype == 1
                ? 'menuclass1'
                : menutype == 2
                  ? 'menuclass2'
                  : 'menuclass3'
                ">
                <el-dropdown-item v-for="(childrenItem, childrenIndex) in item.children" :key="childrenIndex"
                  :command="childrenItem">
                  <!-- <router-link
                    :to="item.url"
                    style="width: 100%; height: 100%"
                    exact
                  >
                    {{ childrenItem.menuName }}</router-link
                  > -->
                  <div @click="menuUrlRouter(childrenItem)" style="color: #333;">
                    {{ childrenItem.menuName }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div
              class="nav_border"
              :style="{
                backgroundColor:
                  menutype == 1
                    ? '#4f8ecb'
                    : menutype == 2
                    ? '#40ABDC'
                    : '#41BAD9',
              }"
            ></div> -->
        </ul>
        <!-- <div class="flex return" v-if="menutype != 1" @click="returnHome">
          <div class="returnIcon"></div>
          <div class="return_text">临床试验中心首页</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      searchInput: "",
      menutype: window.sessionStorage.getItem("menutype"),
      // menuList:
      //   window.sessionStorage.getItem("menutype") == 1
      //     ? JSON.parse(window.sessionStorage.getItem("menuList1"))
      //     : window.sessionStorage.getItem("menutype") == 2
      //     ? JSON.parse(window.sessionStorage.getItem("menuList2"))
      //     : JSON.parse(window.sessionStorage.getItem("menuList3")),
      menuList: [],
      ind: 0,
    };
  },
  computed: {
    menutype: function () {
      return window.sessionStorage.getItem("menutype");
    },
  },

  watch: {
    $route(to, from) {
      if (this.$route.path == "/") {
        this.menutype = 1;
      }
      this.menutype = window.sessionStorage.getItem("menutype");
    },

    menutype: {
      handler(newValue, oldValue) {
        //当词条改变时执行事件
        if (newValue == 1) {
          let menuTimer1 = setInterval(() => {
            if (JSON.parse(window.sessionStorage.getItem("menuList1"))) {
              clearInterval(menuTimer1);
              this.menuList = JSON.parse(
                window.sessionStorage.getItem("menuList1")
              );
            }
          }, 100);
          require.ensure([], function (require) {
            require("@/assets/css/dropdown1.css");
          });
        } else if (newValue == 2) {
          let menuTimer1 = setInterval(() => {
            if (JSON.parse(window.sessionStorage.getItem("menuList2"))) {
              clearInterval(menuTimer1);
              this.menuList = JSON.parse(
                window.sessionStorage.getItem("menuList2")
              );
            }
          }, 100);
          require.ensure([], function (require) {
            require("@/assets/css/dropdown2.css");
          });
        } else if (newValue == 3) {
          let menuTimer1 = setInterval(() => {
            if (JSON.parse(window.sessionStorage.getItem("menuList3"))) {
              clearInterval(menuTimer1);
              this.menuList = JSON.parse(
                window.sessionStorage.getItem("menuList3")
              );
            }
          }, 100);
          require.ensure([], function (require) {
            require("@/assets/css/dropdown3.css");
          });
        }
      },
    },
  },
  created() {
    if (this.menutype == 1) {
      let menuTimer1 = setInterval(() => {
        if (JSON.parse(window.sessionStorage.getItem("menuList1"))) {
          clearInterval(menuTimer1);
          this.menuList = JSON.parse(
            window.sessionStorage.getItem("menuList1")
          );
          // console.log(this.menuList);
        }
      }, 100);
      require.ensure([], function (require) {
        require("@/assets/css/dropdown1.css");
      });
    } else if (this.menutype == 2) {
      let menuTimer1 = setInterval(() => {
        if (JSON.parse(window.sessionStorage.getItem("menuList2"))) {
          clearInterval(menuTimer1);
          this.menuList = JSON.parse(
            window.sessionStorage.getItem("menuList2")
          );
        }
      }, 100);
      require.ensure([], function (require) {
        require("@/assets/css/dropdown2.css");
      });
    } else if (this.menutype == 3) {
      let menuTimer1 = setInterval(() => {
        if (JSON.parse(window.sessionStorage.getItem("menuList3"))) {
          clearInterval(menuTimer1);
          this.menuList = JSON.parse(
            window.sessionStorage.getItem("menuList3")
          );
        }
      }, 100);
      require.ensure([], function (require) {
        require("@/assets/css/dropdown3.css");
      });
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  methods: {
    goBack() {
      let old = window.sessionStorage.getItem("oldmenutype");
      if (old) {
        window.sessionStorage.setItem("menutype", old);
      }

      location.reload();
    },
    check(menu) {
      window.sessionStorage.setItem("oldmenutype", this.menutype);
      if (menu == "医学伦理委员会") {
        //医学伦理委员会
        window.sessionStorage.setItem("menutype", 2);
        this.menutype = 2;
        this.$router.push({
          path: "/ethic",
        });
        // setTimeout(() => {
        //   location.reload();
        // }, 200);
      } else if (menu == "技术转移机构") {
        //技术转移机构
        window.sessionStorage.setItem("menutype", 3);
        this.menutype = 3;
        this.$router.push({
          path: "/technology",
        });
        // setTimeout(() => {
        //   location.reload();
        // }, 200);
      } else if (menu == "临床试验中心") {
        //技术转移机构
        window.sessionStorage.setItem("menutype", 1);
        this.menutype = 1;
        this.$router.push({
          path: "/",
        });
        // setTimeout(() => {
        //   location.reload();
        // }, 200);
      }
    },
    changemenutype(type) {
      this.menutype = type;
    },
    goCommand(command) {
      // console.log(command);
      this.$router.push({
        path: command.url,
        query: {
          id: command.urlId,
          index: command.urlIndex,
          menuName: command.menuName,
          menutype: this.menutype
        },
      });
    },
    returnold() {
      window.open("https://www.znhospital.com/ywsy/index.jhtml", "_blank");
    },
    returnHome() {
      //返回首页
      if (this.menutype == 1) {
        window.open("https://www.znhospital.com", "_blank");
      } else {
        this.menutype = 1;
        window.sessionStorage.setItem("menutype", 1);
        this.$router.push({
          path: "/",
        });
      }

      // location.reload();
    },
    menuUrlRouter(item) {
      if (item.belongSystemId == 1 && item.urlId == '1545341608116715521') {
        window.sessionStorage.setItem("menutype", 2);
        this.menutype = 2;
      } else {
        this.$router.push({
          path: item.url
        })
      }

    }
  },
};
</script>

<style>
.header_search .el-input__inner {
  border: 1px solid #3974d6;
}

.header_search .el-input-group__append {
  background-color: #3f84f7;
  border: 1px solid #3974d6;
}

.header_search .el-icon-search {
  color: #fff;
}
</style>
<style scoped>
.header_top {
  border-bottom: 1px solid #4f8ecb;
}

.header_top_content {
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header_search {
  width: 350px;
  height: 30px;
}

.logo_box {
  height: 55px;
  margin-left: 50px;
}

.logo_left {
  width: 360px;
  height: 52px;
  margin-right: 8px;
  display: block;
  background: url(../../static/images/common/logoLeft.png) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.logo1 {
  width: 200px;
  height: 47px;
  margin-top: 5px;
  background: url(../../static/images/common/logo1.png) no-repeat;
  background-size: 100% 100%;
}

.logo2 {
  width: 200px;
  height: 47px;
  margin-top: 5px;
  background: url(../../static/images/common/logo2.png) no-repeat;
  background-size: 100% 100%;
}

.logo3 {
  width: 200px;
  height: 47px;
  margin-top: 5px;
  background: url(../../static/images/common/logo3.png) no-repeat;
  background-size: 100% 100%;
}

.nav {
  height: 80px;
  line-height: 80px;
  align-items: center;
  justify-content: space-between;
}

.nav ul {
  display: flex;
  list-style-type: none;
  justify-content: space-between;
  width: 100%;
}

.nav ul li {
  text-align: center;
  height: 80px;
  width: 100%;
  margin-left: -20px;
  padding: 0 20px !important;
}

@media screen and (max-width: 1300px) {
  .nav ul li {
    text-align: center;
    height: 80px;
    width: 100%;
    overflow: hidden;
    margin-left: -20px;
    padding: 0 20px !important;
  }
}

.nav ul a {
  font-size: 18px;
  color: #fff;
  text-decoration: none;
}

.nav_main {
  width: 100%;
}

.nav_border {
  width: 1px;
  height: 15px;
  /* position: absolute;
  top: 23px;
  right: 0; */
}

/* .nav_main{
  position: relative;
}
.nav_main:last-child .nav_border{
  display: none;
} */
.active1 .active {
  display: block;
  background-color: #528ee4;
  font-weight: bold;
  /* border-bottom: solid 4px #e3c313; */
}

.nav ul.active1 a:hover {
  display: block;
  background-color: #528ee4;
  font-weight: bold;
}

.active2 .active {
  display: block;
  background-color: #33a5d9;
  font-weight: bold;
  /* border-bottom: solid 4px #e3c313; */
}

.nav ul.active2 a:hover {
  display: block;
  background-color: #33a5d9;
  font-weight: bold;
}

.active3 .active {
  display: block;
  background-color: #33a5d9;
  font-weight: bold;
  /* border-bottom: solid 4px #e3c313; */
}

.nav ul.active3 a:hover {
  display: block;
  background-color: #33a5d9;
  font-weight: bold;
}

#footerPage {
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  height: 60px;
  bottom: 0px;
  width: 100%;
  margin-top: 100px;
  font-size: 12px;
  color: #fff;
  padding-top: 20px;
}

.bannner {
  width: 100%;
  height: 200px;
  background: #1977df;
  opacity: 0.5;
  color: #fff;
  text-align: center;
  line-height: 200px;
  font-size: 20px;
}

.return {
  height: 36px;
  background-color: #0387a8;
  border-radius: 4px;
  padding: 0 12px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.returnIcon {
  width: 16px;
  height: 16px;
  background: url("../../static/images/common/returnIcon.png");
  margin-right: 5px;
  background-size: cover;
}

.return_text {
  font-size: 18px;
  color: #fff;
  line-height: 36px;
}

.header_tooltip_erweima {
  width: 102px;
  height: 102px;
  margin: 0 auto 3px;
}

.header_top_right_in {
  margin-right: 27px;
  font-size: 14px;
  color: #808080;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.header_top_right_in:last-child {
  margin-right: 0;
}

.header_top_right_in i {
  margin-right: 5px;
}

.weixinIcon {
  width: 20px;
  height: 16px;
  background: url(../../static/images/common/weixinIcon.png) no-repeat;
  background-size: cover;
}

.menunew p {
  width: 170px;
  height: 38px;
  border: 1px solid #ddd;
  border-radius: 19px;
  margin-left: 20px;
  text-align: center;
  line-height: 38px;
  font-size: 18px;
  cursor: pointer;
}

.menunew p.chenks {
  background: #2975d3;
  color: #fff;
  border: 1px solid #2975d3;
}

.menunew p:hover {
  background: #2975d3;
  color: #fff;
  border: 1px solid #2975d3;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue